import {makeAutoObservable} from "mobx";

export default class BviStore {
    font = 0;
    intrvl = 0;
    color = 0;

    constructor() {
        makeAutoObservable(this);
    };

    setFont(val: number) {
        this.font = val;
    };

    setIntrvl(val: number) {
        this.intrvl = val;
    };

    setColor(val: number) {
        this.color = val;
    };

};